export default {
    namespaced: true,  // 启用命名空间
    state: {
        wxUserName: "",
        status: "",
        servicePackId: "",
        createTime: "",
    },
    mutations: {
        setWxUserName(state, wxUserName) {
            state.wxUserName = wxUserName;
        },
        setStatus(state, status) {
            state.status = status;
        },
        setServicePackId(state, servicePackId) {
            state.servicePackId = servicePackId;
        },
        setCreateTime(state, createTime) {
            state.createTime = createTime;
        },
        setAllState(state, payload) {
            Object.keys(payload).forEach(key => {
                if (state.hasOwnProperty(key)) {
                    state[key] = payload[key];
                }
            });
        }
    },
}